/* ControlMorePage — §48 */
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/controlApi";
import { ChevronRight, ShieldAlert, Rss, Clock, Settings2, Smartphone, LogOut, Sparkles } from "lucide-react";

function Row({ icon: Icon, label, to, onClick, testId }) {
  const cls = "flex items-center gap-3 p-4 hover:bg-lightgray/50 w-full text-left";
  const content = (
    <>
      <div className="w-9 h-9 border border-softblue bg-white flex items-center justify-center">
        <Icon className="w-4 h-4 text-blueblack" />
      </div>
      <div className="flex-1 text-sm font-bold text-blueblack">{label}</div>
      <ChevronRight className="w-4 h-4 text-textgray" />
    </>
  );
  if (to) return <Link to={to} className={cls} data-testid={testId}>{content}</Link>;
  return <button className={cls} onClick={onClick} data-testid={testId}>{content}</button>;
}

export default function ControlMorePage() {
  const { user, logout } = useAuth();
  return (
    <div className="p-4 space-y-4" data-testid="spc-more">
      <div>
        <div className="text-[10px] uppercase tracking-[0.35em] text-textgray">Más</div>
        <div className="font-serif text-2xl font-bold text-blueblack">Ajustes y sistema</div>
      </div>
      <div className="border border-softblue bg-white p-4">
        <div className="text-[10px] uppercase tracking-widest text-textgray">Sesión</div>
        <div className="text-sm font-bold text-blueblack">{user && user.name}</div>
        <div className="text-xs text-textgray">{user && user.email}</div>
      </div>
      <div className="border border-softblue bg-white divide-y divide-softblue">
        <Row icon={ShieldAlert} label="Sistema" to="/control/more/system" testId="more-system" />
        <Row icon={Rss} label="Fuentes" to="/control/more/sources" testId="more-sources" />
        <Row icon={Clock} label="Tandas" to="/control/more/runs" testId="more-runs" />
        <Row icon={Sparkles} label="Aprendizaje editorial" to="/control/more/learning" testId="more-learning" />
        <Row icon={Settings2} label="Configuración operativa" to="/control/more/settings" testId="more-settings" />
        <Row icon={Smartphone} label="Dispositivos" to="/control/more/devices" testId="more-devices" />
      </div>
      <button onClick={logout} data-testid="spc-logout"
        className="w-full h-11 border border-softblue bg-white text-blueblack text-[11px] uppercase tracking-widest font-bold flex items-center justify-center gap-1.5">
        <LogOut className="w-3.5 h-3.5" /> Cerrar sesión
      </button>
      <div className="text-center text-[10px] text-textgray pt-4">
        SUR PRIMICIA CONTROL · v1.0
      </div>
    </div>
  );
}
